module.exports = __webpack_public_path__ + "static/9-c434e67f8bcd90783aedc043a932f57a.jpg";